import React, { useId } from "react";

/** Plain centred dialog shared by the template screens. */
export default function Modal({ title, onClose, children }) {
  const titleId = useId();

  return (
    <div
      style={{ marginTop: 0 }}
      className="fixed inset-0 bg-black bg-opacity-50 flex items-start sm:items-center justify-center z-50 p-0 sm:p-4"
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        className="bg-white sm:rounded-xl shadow-2xl max-w-lg w-full max-h-[100vh] sm:max-h-[90vh] overflow-y-auto"
      >
        <div className="border-b px-5 py-4 flex items-center justify-between">
          <h2 id={titleId} className="text-lg font-bold text-gray-800">{title}</h2>
          <button onClick={onClose} aria-label="Close" className="text-gray-500 hover:text-gray-700 text-xl">
            ✕
          </button>
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
}
